import {useEffect, useState} from 'react'
import {css} from '@emotion/react'
import http from '@/biz/http.mjs'

const cssTestScreenshot = css({
    display: 'grid',
    gridTemplateRows: 'auto auto auto auto 1fr',
    width: '100%',
    height: '100%',
    overflow: 'hidden',

    '&>:last-child': {
        overflow: 'auto',
    },
})

export default function TestScreenshot(props) {
    const [origin, setOrigin] = useState('http://localhost:3000')
    const [flowId, setFlowId] = useState()
    const [mapId, setMapId] = useState()
    const [prototypeId, setPrototypeId] = useState()
    const [imgBlob, setImgBlob] = useState()
    const [imgSrc, setImgSrc] = useState()

    useEffect(
        () => {
            if (! imgBlob) {
                return
            }

            const url = URL.createObjectURL(imgBlob)
            setImgSrc(url)

            return () => URL.revokeObjectURL(url)
        },

        [imgBlob]
    )

    const onChangeOrigin = e => setOrigin(e.target.value)
    const onChangeFlowId = e => setFlowId(e.target.value)
    const onChangeMapId = e => setMapId(e.target.value)
    const onChangePrototypeId = e => setPrototypeId(e.target.value)

    const testFlow = async () => {
        const {wfMap} = await http.get(`/oneBmBfWf?pkid=${flowId}`)
        const {blob} = await http.post(`${origin}/convert-flow/image`, {wfMap})
        setImgBlob(blob)
    }

    const testMap = async () => {
        const {mapModel} = await http.get(`/basmaps/${mapId}`)
        const mapData = JSON.parse(mapModel)

        const args = {
            inits: {showNodeDesc: true},
            mapData,
        }

        const {blob} = await http.post(`${origin}/convert-map/image`, args)
        setImgBlob(blob)
    }

    const testPrototype = async () => {
        const args = await http.get(`/oneUmUv?pkid=${prototypeId}`)
        const {blob} = await http.post(`${origin}/convert-uv/image`, args)
        setImgBlob(blob)
    }

    return (
        <div
            css={cssTestScreenshot}
            {...props}
        >
            <div>
                <label>服务器地址</label>

                <input
                    type="text"
                    value={origin}
                    onChange={onChangeOrigin}
                />
            </div>

            <div>
                <label>地图ID</label>

                <input
                    type="text"
                    value={mapId}
                    onChange={onChangeMapId}
                />

                <button onClick={testMap}>截图</button>
            </div>

            <div>
                <label>原型ID</label>

                <input
                    type="text"
                    value={prototypeId}
                    onChange={onChangePrototypeId}
                />

                <button onClick={testPrototype}>截图</button>
            </div>

            <div>
                <label>流程ID</label>

                <input
                    type="text"
                    value={flowId}
                    onChange={onChangeFlowId}
                />

                <button onClick={testFlow}>截图</button>
            </div>

            <div>
                <img src={imgSrc} />
            </div>
        </div>
    )
}
